<p-dialog
  [modal]="true"
  [(visible)]="isVisible"
  (onHide)="onDialogHide()"
  [dismissableMask]="true"
  [header]="formType + ' Station Log'"
  [styleClass]="!isLoading ? 'main-dialog' : ''"
  [focusOnShow]="false"
>
  <app-progress-spinner [enabled]="saving" />
  @if (!isLoading) {
    <div class="container">
      <div class="center">
        <form [formGroup]="stationLogForm">
          <div formGroupName="stationLog">
            @if (this.formType === 'Edit') {
              <div class="actions-dropdown">
                <span class="label"
                  >{{ 'COMMON.LABEL.ACTIONS' | translate }}:</span
                >
                <span class="align-left">
                  <p-select
                    [options]="actions"
                    (onChange)="actionEvent($event, dd)"
                    [(ngModel)]="selectedAction"
                    [ngModelOptions]="{ standalone: true }"
                    styleClass="action-drop-down"
                    #dd
                  />
                </span>
              </div>
            }
            <div class="card-header">
              <h2>
                {{ 'OPMONITORING.LABEL.STATION_LOG_DETAILS' | translate }}
              </h2>
            </div>
            <div class="station-log-details">
              <div class="row">
                <div id="createdAt" class="text-center" class="row-item">
                  <label for="createdAt"
                    >{{ 'OPMONITORING.LABEL.DATE' | translate }}:
                    <span class="required">*</span>
                  </label>
                  <p-datepicker
                    class="input"
                    formControlName="createdAt"
                    appendTo="body"
                    #calender
                  />
                </div>

                <div class="row-item">
                  <label for="reason"
                    >{{ 'OPMONITORING.LABEL.REASON' | translate }}:
                    <span class="required">*</span></label
                  >
                  <p-select
                    class="input"
                    formControlName="reason"
                    [options]="stationLogReasons"
                    optionLabel="reason"
                    placeholder="{{
                      'OPMONITORING.MESSAGES.PLACEHOLDER.REASON' | translate
                    }}"
                    appendTo="body"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="30"
                    scrollHeight="calc(100vh-35vh)"
                  />
                </div>

                <div class="row-item">
                  <label for="unitHours"
                    >{{ 'OPMONITORING.LABEL.UNIT_HOURS' | translate }}:
                  </label>
                  <p-inputNumber
                    mode="decimal"
                    formControlName="unitHours"
                    class="p-inputNumber"
                    appendTo="body"
                  />
                </div>
              </div>
              <div class="text-row">
                <div class="text-item">
                  <label for="message"
                    >{{ 'OPMONITORING.LABEL.ALARM_OR_SHUTDOWN' | translate }}:
                  </label>
                  <textarea
                    pTextarea
                    class="input"
                    [rows]="3"
                    [cols]="100"
                    formControlName="message"
                    appendTo="body"
                  ></textarea>
                </div>

                <div class="text-item">
                  <label for="fixSolution"
                    >{{ 'OPMONITORING.LABEL.FIX_SOLUTION' | translate }}:
                  </label>
                  <textarea
                    pTextarea
                    class="input"
                    [rows]="3"
                    [cols]="100"
                    formControlName="fixSolution"
                    appendTo="body"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <p-divider />
          <div formGroupName="contactLocInfo" class="info-form">
            <div class="card-header">
              <h2>
                {{ 'OPMONITORING.LABEL.FACILITY_STATION_INFO' | translate }}
              </h2>
            </div>
            <div class="row">
              <div class="facility-name row-item facility-name-row-item">
                <label for="facility"
                  >{{ 'OPMONITORING.LABEL.FACILITY' | translate }}:
                  <span class="required">*</span></label
                >
                <p-select
                  class="input"
                  formControlName="facility"
                  placeholder="{{
                    'CRM.MESSAGES.PLACEHOLDER.FACILITY' | translate
                  }}"
                  [options]="facilities"
                  optionLabel="facilityName"
                  [filter]="true"
                  filterBy="facilityName"
                  (onChange)="onFacilityChange($event)"
                  appendTo="body"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="30"
                />
              </div>
              <div class="facility-id row-item">
                <label for="facilityId"
                  >{{ 'OPMONITORING.LABEL.FACILITY_ID' | translate }}:
                  <span class="required">*</span></label
                >
                <p-select
                  class="facility-id-input"
                  formControlName="facilityId"
                  placeholder="{{
                    'CRM.MESSAGES.PLACEHOLDER.FACILITY_ID' | translate
                  }}"
                  [options]="facilityIds"
                  optionLabel="facilityUid"
                  [filter]="true"
                  filterBy="facilityUid"
                  (onChange)="onFacilityIdChange($event)"
                  appendTo="body"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="30"
                />
              </div>
            </div>
          </div>
          @if (this.showFormBasedOnPermissions()) {
            <button
              pButton
              pRipple
              type="button"
              label="{{ 'COMMON.LABEL.BUTTONS.SAVE' | translate }}"
              class="p-button-raised p-button-success save-btn"
              [disabled]="
                !this.stationLogForm.valid || !this.stationLogForm.dirty
              "
              (click)="onSubmit()"
            ></button>
          }
        </form>
      </div>
    </div>
  }
</p-dialog>
<p-toast />
